module.exports = __webpack_public_path__ + "static/media/ecpy.ad0495d0.png";